module.exports = __webpack_public_path__ + "static/media/arrow-down-green-stroke.8a40d105.svg";